import { useState, useEffect } from "react";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { ThumbsUp, ExternalLink, Clapperboard } from "lucide-react";

export default function Reels() {
  const [reels, setReels] = useState([]);
  const [voted, setVoted] = useState(() => JSON.parse(localStorage.getItem("sw_votes") || "[]"));

  const load = () => api.get("/reels").then(({ data }) => setReels(data));
  useEffect(() => { load(); }, []);

  const vote = async (id) => {
    if (voted.includes(id)) return toast.info("You already voted for this reel");
    await api.post(`/reels/${id}/vote`);
    const v = [...voted, id];
    setVoted(v);
    localStorage.setItem("sw_votes", JSON.stringify(v));
    toast.success("Vote counted!");
    load();
  };

  return (
    <div className="max-w-5xl mx-auto px-4 py-10 fade-up">
      <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#c8102e] mb-2">People's Choice</p>
      <h1 className="font-display text-4xl font-bold text-[#1a1f36] mb-2">The Reels</h1>
      <p className="text-slate-600 mb-8">Every property films one short reel. Vote for your favorite — votes are for glory only and never affect the score.</p>
      {reels.length === 0 ? (
        <div className="text-center py-20 border border-dashed border-slate-300 rounded-md" data-testid="no-reels-empty">
          <Clapperboard className="w-10 h-10 text-slate-300 mx-auto mb-3" />
          <p className="text-slate-500">No reels submitted yet — check back soon.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-4 stagger">
          {reels.map((r) => (
            <div key={r.id} className="border border-slate-200 rounded-md p-5 hover:shadow-md transition-shadow" data-testid={`reel-card-${r.id}`}>
              <div className="font-semibold text-[#1a1f36]">{r.property_name}</div>
              <div className="text-xs text-slate-500 mb-3">{r.location} · {r.division}{r.tier ? ` · ${r.tier}` : ""}</div>
              <div className="flex items-center justify-between">
                <a href={r.video_url} target="_blank" rel="noreferrer" className="text-sm text-[#c8102e] font-medium hover:underline inline-flex items-center gap-1" data-testid={`reel-watch-${r.id}`}>
                  Watch reel <ExternalLink className="w-3.5 h-3.5" />
                </a>
                <Button size="sm" variant={voted.includes(r.id) ? "secondary" : "outline"} onClick={() => vote(r.id)} data-testid={`reel-vote-${r.id}`}>
                  <ThumbsUp className="w-4 h-4 mr-1" /> {r.votes}
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
